import type { LineItemStateKey } from "@/pages/(app)/returns/refund/hooks/use-line-items-state-context";
import { createContext, PropsWithChildren, useContext, useState } from "react";

type ReturnValidationContextType = {
  isOpen: boolean;
  openDialog: (options?: {
    openedByScanner?: boolean;
    stateKey?: LineItemStateKey;
  }) => void;
  closeDialog: () => void;
  openedByScanner: boolean;
  scannerStateKey: LineItemStateKey | null;
};

const ReturnValidationContext = createContext<ReturnValidationContextType>({
  isOpen: false,
  openDialog: () => {},
  closeDialog: () => {},
  openedByScanner: false,
  scannerStateKey: null,
});

export function useReturnValidationContext() {
  return useContext(ReturnValidationContext);
}

export function ReturnValidationProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState(false);
  const [openedByScanner, setOpenedByScanner] = useState(false);
  const [scannerStateKey, setScannerStateKey] =
    useState<LineItemStateKey | null>(null);

  const openDialog = (options?: {
    openedByScanner?: boolean;
    stateKey?: LineItemStateKey;
  }) => {
    setOpenedByScanner(options?.openedByScanner ?? false);
    setScannerStateKey(options?.stateKey ?? null);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setOpenedByScanner(false);
    setScannerStateKey(null);
  };

  return (
    <ReturnValidationContext.Provider
      value={{
        isOpen,
        openDialog,
        closeDialog,
        openedByScanner,
        scannerStateKey,
      }}
    >
      {children}
    </ReturnValidationContext.Provider>
  );
}
